<template>
  <div>
    <div class="subtab">
      <div
        v-for="(item, index) in subtabs"
        :key="index"
        class="subtab-item"
        :class="{ active : item.category === category }"
        @click="changeSubTab(item.category)"
      >{{item.name}}</div>
    </div>
    <m-textArea class="data-list hasSubtab" ref="dataList">
      <VideoList
        :datalist="datalist"
        category="documentary"
        @play="$emit('playVideo', $event)"
      ></VideoList>
      <Pagination
        :num="pageNow"
        :pages="pages"
        @change="chagenPage"
      ></Pagination>
    </m-textArea>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";

import TextArea from "@/components/TextArea";
import VideoList from './VideoList';
import Pagination from "@/components/Pagination";

export default {
  components: {
    "m-textArea": TextArea,
    Pagination,
    VideoList
  },
  data() {
    return {
      subtabs: [
        {
          name: "动画作品",
          category: "平面设计-动画作品"
        },
        {
          name: "开关机动画",
          category: "平面设计-开关机动画"
        }
      ],
      category: "平面设计-动画作品"
    }
  },
  computed: {
    ...mapState(["extension"]),
    datalist() {
      return this.extension[this.pageNow]
    },
    pageNow() {
      return this.extension.number
    },
    pages() {
      return this.extension.total_pages;
    }
  },
  mounted() {
    this.getPageData({
      category: this.category
    });
  },
  methods: {
    ...mapActions(["getExtension"]),
    getPageData({page_num = 0, category}) {
      const param = {
        category,
        page_num
      };
      this.getExtension(param);
    },
    chagenPage(num) {
      this.getPageData({
        page_num: num,
        category: this.category
      });
      this.$refs.dataList.scroll();
    },
    changeSubTab(category) {
      this.getPageData({
        category
      });
      this.category = category;
      this.$refs.dataList.scroll();
    }
  }
}
</script>
